import { render, staticRenderFns } from "./vvbprocessmodal.vue?vue&type=template&id=57e5acbf&scoped=true&"
import script from "./vvbprocessmodal.vue?vue&type=script&lang=js&"
export * from "./vvbprocessmodal.vue?vue&type=script&lang=js&"
import style0 from "./vvbprocessmodal.vue?vue&type=style&index=0&id=57e5acbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e5acbf",
  null
  
)

export default component.exports